import { useRef, forwardRef, useImperativeHandle, useEffect } from "react";
import Scroller from "./scroller";
import styles from "./style.module.less";
import { map } from "lodash-es";

type VerticalSeamlessScrollerProps = {
  width: number | string;
  height: number | string;
  items: { render: () => JSX.Element }[];
  onEnd?: (index: number) => void;
  scrollSpeed: number; // 每秒滚动像素数（px/s）
  transitionSpeed: number; // 缓动动画时长（毫秒）
  initialSlide: number; // 初始显示条目索引（从 0 开始）
  directionUp: boolean; // 初始滚动方向
};

type VerticalSeamlessScrollerHandle = {
  start: () => void;
  stop: (index: number) => void;
};

const VerticalSeamlessScroller = forwardRef<
  VerticalSeamlessScrollerHandle,
  VerticalSeamlessScrollerProps
>(({ items, width, height, onEnd, ...rest }, ref) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const scrollerRef = useRef<Scroller>();

  useEffect(() => {
    scrollerRef.current = new Scroller(containerRef.current, {
      itemSelector: `.${styles["v-seamless-scroller-item"]}`,
      ...rest,
      onEnd,
    });
  }, []);

  useImperativeHandle(ref, () => {
    return {
      start: () => {
        scrollerRef.current?.start();
      },
      stop: (index: number) => {
        scrollerRef.current?.stop(index);
      },
    };
  });

  return (
    <div
      className={styles["v-seamless-scroller"]}
      ref={containerRef}
      style={{ width: width, height: height }}
    >
      {map(items, (item, index) => (
        <div key={index} className={styles["v-seamless-scroller-item"]}>
          {item?.render?.(item, index)}
        </div>
      ))}
    </div>
  );
});

export default VerticalSeamlessScroller;
